/**
 * 配置编译环境和线上环境之间的切换
 * 
 * host: 域名地址
 * urlPerfix: 接口地址
 * uploadAliyunOss: 是否上传到阿里云OSS
 * uploadFileFormat: 上传文件类型
 * 
 */

let host = 'http://localhost:8080'
if (process.env.NODE_ENV == 'production') {
	host = 'https://api.qsm.lforient.com';
}

const urlPerfix = host + "/api/v1"
const urlPerfixV2 = host + "/api/v2"

let uploadLimitSize = { //单位M
	image: 10,
	file: 20,
}

export {
	host,
	urlPerfix,
	urlPerfixV2,
	uploadLimitSize,
}